import { Surface } from '@westhetics/ui'
import type { ReactNode } from 'react'

/** Cartão à parte do salvar: o que a ação faz à esquerda, o botão à direita, os campos embaixo. */
export function ActionCard({
  id,
  title,
  description,
  action,
  children,
}: {
  id?: string
  title: string
  description: ReactNode
  action: ReactNode
  children?: ReactNode
}) {
  return (
    <Surface id={id} className="max-desk:px-4">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="max-w-[520px]">
          <h2 className="font-display text-lead text-ink leading-[1.3] font-normal">{title}</h2>
          <p className="font-body text-secondary mt-1 text-[12px] leading-[1.6] font-light">
            {description}
          </p>
        </div>
        {action}
      </div>
      {children ? (
        <div className="border-hairline mt-4 flex flex-col gap-4 border-t pt-4">{children}</div>
      ) : null}
    </Surface>
  )
}
